<template>
  <div class="text-courseware-page">
    <!-- 顶部Banner -->
    <Banner />
    <div class="content-wrapper">
      <div class="left-list">
        <!-- 分类导航 -->
        <nav-filter />
        <!-- 面包屑 -->
        <div class="breadcrumb-bar">
          <button class="breadcrumb-back" @click="$router && $router.back ? $router.back() : window.history.back()">返回</button>
          <span class="breadcrumb-link">万知学习</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ teacherInfo.zhiwu }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ teacherInfo.name }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-current">{{ type === 3 ? '付费' : '免费' }}视频课件列表</span>
        </div>
        <!-- tab切换 -->
        <div class="tabs-bar">
          <div class="tab-group">
            <span :class="['tab', activeTab === 'latest' ? 'active' : '']" @click="changeTab('latest')">最新</span>
          <span :class="['tab', activeTab === 'read' ? 'active' : '']" @click="changeTab('read')">阅读人数</span>
          </div>
          <div class="view-switch">
            <img
              :src="viewType === 'list' ? require('@/assets/images/video-list-active.png') : require('@/assets/images/video-list.png')"
              class="view-icon"
              @click="viewType = 'list'"
              alt="列表"
            />
            <img
              :src="viewType === 'card' ? require('@/assets/images/video-grid-active.png') : require('@/assets/images/video-grid.png')"
              class="view-icon"
              @click="viewType = 'card'"
              alt="卡片"
            />
          </div>
        </div>
        <!-- 课件列表 -->
        <div v-if="viewType === 'list'" class="courseware-list">
          <div class="courseware-item" v-for="item in list" :key="item.id" @click="handleClickDetail(item)">
            <div class="item-left">
              <div class="item-cover-wrapper">
                <img class="item-cover" :src="item.cover" alt="封面" />
                <span class="video-duration">05:20</span>
              </div>
              <div class="video-info">
                <div class="item-title">{{ item.title }}</div>
                <div class="item-info">
                  <span class="item-read"><img src="@/assets/images/eye.png" class="info-icon" /> 阅读：<span class="green">{{ item.read }}</span></span>
                  <span class="item-comment"><img src="@/assets/images/ly.png" class="info-icon" /> 留言：{{ item.comment }}</span>
                  <span class="item-date"><img src="@/assets/images/time.png" class="info-icon" />{{ item.date }}</span>
                </div>
              </div>
            </div>
            <el-button class="item-btn" size="mini" type="text">查看</el-button>
          </div>
        </div>
        <div v-else class="courseware-list card-mode">
          <div class="courseware-card-item" v-for="item in list" :key="item.id" @click="handleClickDetail(item)">
            <div class="item-cover-wrapper">
              <img class="item-cover" :src="item.cover" alt="封面" />
              <div class="play-icon">
                <img src="@/assets/images/play-icon.png" alt="播放" />
              </div>
              <span class="video-duration card-duration">05:20</span>
            </div>
            <div class="card-info">
              <div class="item-title">{{ item.title }}</div>
              <div class="item-date"><img src="@/assets/images/time.png" class="info-icon" />{{ item.date }}</div>
            </div>
          </div>
        </div>
        <!-- 分页 -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          class="pagination-bar"
        />
      </div>
      <div class="right-news">
        <!-- <ad-sidebar /> -->
        <v-right :marketBannerSmall="marketBannerSmall" :marTop="false"></v-right>
      </div>
    </div>
  </div>
</template>

<script>
import sign from '@/auth/sign'
import url from '@/axios/url'
import Banner from '@/components/common/Banner.vue'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter.vue'
import { getKejianList, getEduDetails } from '@/axios/education'
export default {
  name: 'TextCourseware',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    NavFilter
  },
  data () {
    return {
      picUrl: url.picUrl,
      activeTab: 'latest',
      viewType: 'list',
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      sort: 1, // 1:最新, 2:阅读人数
      teacher_id: parseInt(this.$route.query.teacher_id) || 1, // 默认1，实际应从路由获取
      type: parseInt(this.$route.query.type) || 2, // 免费视频课件
      teacherInfo: {
        name: '',
        position: '',
        subject: ''
      }
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    }
  },
  created () {
    this.getTeacherInfo()
    this.getLists()
  },
  methods: {
    handleClickDetail (item) {
      this.$router.push({ name: 'VideoCoursewareDetail', query: { id: item.id, type: this.type } })
    },
    getTeacherInfo () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.teacher_id,
        type: 3
      }
      const signO = sign(params)
      params.sign = signO
      getEduDetails(params).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data
          this.teacherInfo = {
            name: data.realname || '',
            zhiwu: data.zhiwu || ''
          }
        }
      })
    },
    changeTab (tab) {
      if (this.activeTab !== tab) {
        this.activeTab = tab
        this.sort = tab === 'latest' ? 1 : 2
        this.page = 1
        this.getLists()
      }
    },
    getLists () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        teacher_id: this.teacher_id,
        type: this.type,
        page: this.page,
        sort: this.sort
      }
      const signO = sign(params)
      params.sign = signO
      getKejianList(params).then(res => {
        if (res.data.msg === '请求成功') {
          const data = res.data.data
          this.list = (data.lists || []).map(item => ({
            id: item.id,
            title: item.title,
            read: item.clickcount,
            comment: item.liuyancount,
            date: item.inputtime,
            cover: `${this.picUrl}${item.fengmian}`,
            video_url: item.fileurl
          }))
          this.total = data.total || 0
        } else {
          this.list = []
          this.total = 0
        }
      }).catch(() => {
        this.list = []
        this.total = 0
      })
    }
  }
}
</script>

<style scoped>
.text-courseware-page {
  background: #fff;
  padding-bottom: 20px;
}
.content-wrapper {
  display: flex;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.left-list {
  flex: 1;
  margin-right: 20px;
}
.right-news {
  width: 320px;
}
.breadcrumb-bar {
  display: flex;
  align-items: center;
  background: #F9F9F9;
  border-radius: 6px;
  padding: 8px 18px;
  margin-bottom: 16px;
  font-size: 14px;
}
.breadcrumb-back {
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #888;
  border-radius: 4px;
  padding: 2px 10px;
  margin-right: 16px;
  height: 28px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
}
.breadcrumb-back:hover {
  background: #f2f2f2;
  border-color: #ccc;
}
.breadcrumb-link {
  color: #666;
}
.breadcrumb-separator {
  color: #ccc;
  margin: 0 4px;
}
.breadcrumb-current {
  color: #EF8432;
  font-weight: bold;
}
.tabs-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.tab-group {
  display: flex;
  gap: 24px;
}
.tab {
  font-size: 16px;
  color: #666;
  cursor: pointer;
  padding-bottom: 4px;
  border-bottom: 2px solid transparent;
}
.tab.active {
  color: #EF8432;
  font-weight: bold;
  border-bottom: 2px solid #EF8432;
}
.view-switch {
  display: flex;
  gap: 8px;
}
.view-icon {
  width: 22px;
  height: 22px;
  cursor: pointer;
}
.courseware-list {
  margin-bottom: 20px;
}
.courseware-item {
  display: flex;
  align-items: flex-start;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 1px 4px rgba(0,0,0,.05);
  padding: 12px 18px;
  margin-bottom: 16px;
  min-height: 90px;
  position: relative;
}
.item-left {
  display: flex;
  align-items: center;
  flex: 1;
}
.item-cover-wrapper {
  position: relative;
  width: 200px;
  height: 128px;
  flex-shrink: 0;
  margin-right: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-cover {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  object-fit: cover;
  display: block;
}
.video-duration {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  background: rgba(0,0,0,0.5);
  color: #fff;
  font-size: 13px;
  border-radius: 0 0 6px 6px;
  padding: 4px 0;
  line-height: 1;
  text-align: center;
}
.video-info {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 128px;
  gap: 0;
}
.item-title {
  font-size: 16px;
  color: #181818;
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 6px;
}
.item-info {
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 13px;
  color: #3D3D3D;
  margin-bottom: 0;
}
.item-read {
  color: #3DB963;
  display: flex;
  align-items: center;
  gap: 2px;
}
.item-comment {
  display: flex;
  align-items: center;
  gap: 2px;
}
.item-date {
  margin-left: 8px;
  display: flex;
  align-items: center;
  gap: 2px;
}
.item-btn {
  color: #EF8432;
  border: 1px solid #EF8432;
  background-color: rgb(253,242,234);
  border-radius: 4px;
  padding: 4px 18px;
  font-size: 14px;
  height: 32px;
  display: flex;
  align-items: center;
  transition: background 0.2s;
  align-self: flex-start;
  margin-left: auto;
  margin-top: 0;
  position: absolute;
  right: 18px;
  top: 12px;
}
.item-btn:hover {
  background: #fff7f0;
  color: #EF8432;
  border-color: #EF8432;
}
.pagination-bar {
  text-align: center;
  margin-top: 20px;
}
.green {
  color: #3DB963;
}
.info-icon {
  width: 20px;
  height: 20px;
  object-fit: contain;
  margin-right: 2px;
  vertical-align: middle;
}
.courseware-list.card-mode {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px 18px;
  margin-bottom: 20px;
}
.courseware-card-item {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0,0,0,.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  position: relative;
  width: 200px;
  transition: transform 0.2s, box-shadow 0.2s;
  border: none;
  overflow: hidden;
}
.courseware-card-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0,0,0,.12);
}
.item-cover-wrapper {
  position: relative;
  width: 200px;
  height: 128px;
  flex-shrink: 0;
  margin-right: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.item-cover {
  width: 100%;
  height: 100%;
  border-radius: 6px;
  object-fit: cover;
  display: block;
}
.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.play-icon img {
  width: 100%;
  height: 100%;
}
.card-duration {
  left: auto;
  right: 0;
  bottom: 0;
  width: auto;
  border-radius: 4px 0 0 0;
  padding: 2px 8px;
}
.card-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: calc(100% - 32px);
  padding: 12px 16px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}
.card-info .item-title {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin-bottom: 8px;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.4;
}
.card-info .item-date {
  font-size: 12px;
  color: #999;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  margin: 0;
}
.card-info .item-date .info-icon {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}
@media (max-width: 1100px) {
  .courseware-list.card-mode {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (max-width: 700px) {
  .courseware-list.card-mode {
    grid-template-columns: 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/VideoCoursewareList.vue